import {isNotNil} from 'ramda-adjunct';

import {useGetCurrentUserInfoQuery} from '@dms/api/customer';
import {CountryAlpha3CodeEnumSchema, CountryResponseBody} from '@dms/api/shared';

export function useSourcingTargetCountry(): CountryResponseBody | null {
  const {data} = useGetCurrentUserInfoQuery();

  const countryCode = data?.settings.country;

  if (!isNotNil(countryCode)) {
    return null;
  }

  const validationResult = CountryAlpha3CodeEnumSchema.safeParse(countryCode);

  return validationResult.success
    ? {
        name: validationResult.data,
        code: validationResult.data,
        preferred: false,
      }
    : null;
}
